/**
 * Service for getting attendance-data
 */



import helpers from './DataserviceHelpers.js'
import Backend from '../Backend'
import CourseDateData from "./CourseDateData";

/* @ngInject */
class CourseData {

  static searchCourse = function(name) {
    // const fields = ["KS_ID", "KS_Kursname", "KS_Dauer", "KS_Preis", "KS_Bemerkungen"];
    // const fieldlist = helpers.generateFieldlist()

    return Backend.getData(`/api/TAB_KURSSTAMMDATEN/search?KS_Kursname=${name}`)
  }

  static fetchCourseBaseData = function(id) {
    const fields = ["KS_ID", "KS_Kursname"]
    const fieldlist = helpers.generateFieldlist(fields)

    return Backend.getData(`/api/TAB_KURSSTAMMDATEN/${id}?${fieldlist}`)
      .then(res => res[0])
  }

  static fetchDatesByCourseID = function (courseID) {
    return CourseData.fetchCourseBaseData(courseID).then((course) => {
      return CourseData.fetchDates(course);
    });
  }

  static fetchDates = function(course) {
    const fields = ["KD_ID", "KD_Anfangstag", "KD_Letzter_Tag", "KD_Veranstaltungsort", "KD_Beginn", "KD_Ende", "KD_Bemerkungen", "KD_Bearbeiter", "KD_Referent"]
    const fieldlist = helpers.generateFieldlist(fields)

    return Backend.getData(`${course._links["Kurstermine dieses Stammkurses"].href}?${fieldlist}`)
  }

  // Setzt serverseitig nur das KS_isdeleted-Flag (Soft-Delete),
  // Kurstermine und Teilnahme-Historie bleiben erhalten.
  static deleteCourse = function(courseID) {
    return Backend.deleteData(`/api/TAB_KURSSTAMMDATEN/${courseID}`)
  }

  static deleteCourseAndAllCourseDates = function(courseID) {
    return CourseData.fetchCourseBaseData(courseID).then((course) => {
      return CourseData.fetchDates(course).then(dates => {
        let counter = 0;
        if(dates != null && dates !== '') {
          dates.forEach(date => {
            counter++;
            return CourseDateData.deleteDate(date.KD_ID).then(value => {
              if (counter === dates.length) {
                return Backend.deleteData(`/api/TAB_KURSSTAMMDATEN/${courseID}`);
              }
            });
          });
        } else {
          return Backend.deleteData(`/api/TAB_KURSSTAMMDATEN/${courseID}`);
        }
      });
    });
  }
}
export default CourseData;
